import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getSocialLinks = createAsyncThunk('socialLinks/getSocialLinks', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getSocialLinks();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
